export default __webpack_public_path__ + "static/media/rakhi2.55fbb7c6.jpeg";